import React, { useEffect, useRef, useCallback } from "react";
import "./SearchBar.scss";
import { withRouter } from "react-router-dom";
import SearchIcon from "../../assets/images/search.svg";

function SearchBar({ display, setDisplay, history }) {
  const inputRef = useRef(null);
  const containerRef = useRef(null);
  const isOpen = display === "--show";

  const close = useCallback(() => {
    setDisplay("--hide");
  }, [setDisplay]);

  useEffect(() => {
    if (!isOpen) return;
    const t = window.setTimeout(() => inputRef.current?.focus(), 0);
    const onKey = (e) => {
      if (e.key === "Escape") close();
    };
    const onPointerDown = (e) => {
      if (!containerRef.current) return;
      if (containerRef.current.contains(e.target)) return;
      if (e.target.closest("[data-search-trigger]")) return;
      close();
    };
    document.addEventListener("keydown", onKey);
    document.addEventListener("pointerdown", onPointerDown);
    return () => {
      window.clearTimeout(t);
      document.removeEventListener("keydown", onKey);
      document.removeEventListener("pointerdown", onPointerDown);
    };
  }, [isOpen, close]);

  const submitHandler = (event) => {
    event.preventDefault();
    const q = event.target.search.value.trim();
    if (!q) return;
    history.push(`/search/${encodeURIComponent(q.toLowerCase())}`);
    close();
    event.target.reset();
  };

  return (
    <div ref={containerRef} className={`searchbar${display}`}>
      {isOpen && (
        <button
          type="button"
          className="searchbar__backdrop"
          aria-label="Close search"
          onClick={close}
        />
      )}
      <form
        className="searchbar__form"
        onSubmit={submitHandler}
        role="search"
        aria-label="Site search"
      >
        <div className="searchbar__control">
          <img
            src={SearchIcon}
            alt=""
            className="searchbar__leading-icon"
            aria-hidden
          />
          <input
            ref={inputRef}
            name="search"
            type="search"
            className="searchbar__textbox"
            placeholder="Search the collection"
            autoComplete="off"
            enterKeyHint="search"
          />
          <button type="submit" className="searchbar__submit">
            Search
          </button>
        </div>
      </form>
    </div>
  );
}

export default withRouter(SearchBar);
